/*
  add selected
*/
/**
 * Desktop/Mobile feature. Use GROUP_OPTION inputs to add a selected attribut to
 * given select
 */

/************************************************
		GET GROUP OPTIONS AND APPLY SELECTED ATTRIBUT
*************************************************/
function __addselected() {

  //-- get options
  var options = $("input[data-kind=GROUP_OPTION][data-type=add-selected]");

  //-- if some options found
  if (options.length > 0) {

    //-- go though options found
    options.each(function() {

      //-- init
      var option = $(this);

      //-- get targeted select class & option value of the option
      var select_class = "." + option.attr("data-name");
      var select_value = option.val();

      //-- try to get the targeted select
      var targeted_select = $(select_class);

      //-- if found...
      if (targeted_select.length > 0) {

        //-- go through each options of the select and add selected to the right one
        targeted_select.find("option").each(function(){
          if ($(this).val() == select_value)
            $(this).attr("selected","selected");
        });
      }
    });
  }
}

//-- exec
setTimeout(function() { __addselected(); }, 10);
